<template>

    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-input v-model="query.epcCode" clearable placeholder="EPC"></el-input>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.brandId" clearable placeholder="Business Code">
                    <el-option v-for="(item,index) in brandList" :key="index" :label="item.businessCode" :value="item.id">
                        <span style="float: left">{{ item.brandName }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.businessCode }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.status" clearable placeholder="State">
                    <el-option key="1" label="Sold" value="1"></el-option>
                    <el-option key="0" label="Return" value="0"></el-option>

                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-input v-model="query.storeCode" clearable placeholder="Store Code"></el-input>
            </el-form-item>
            <el-form-item class="query-form-item">
                 <div class="block">
                    <el-date-picker v-model="sellTime"  type="datetimerange" range-separator="-" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="Sales Start Time" end-placeholder="Sales End Time"></el-date-picker>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button type="primary" icon="search" @click="getList">Query</el-button>
                    <el-button type="primary" @click="exportCsv">Export</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;">
            <el-table  v-loading="loading"  :data="list"  style="width: 100%;">
                <el-table-column label="No." type="index" width="50"> </el-table-column>
                <el-table-column label="EPC" prop="epcCode" width="300" > </el-table-column>
                <el-table-column label="State" prop="status" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">Sold</span>
                        <span v-if="scope.row.status == 0">Return</span>
                    </template>
                </el-table-column>
                <el-table-column label="Brand Name" prop="brandName" width="120"></el-table-column>
                <el-table-column label="Business Code" prop="businessCode" width="130"></el-table-column>
                <el-table-column label="Store Code" prop="storeCode" width="120">
                    <!-- <template slot-scope="scope">
                        <span>{{eacListFun(scope.row.store_id)}}</span>
                    </template> -->
                </el-table-column>
                <el-table-column label="Sales Time" with="300" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <i v-if="scope.row.sellTime" class="el-icon-time"></i>
                        <span> {{ scope.row.sellTime | formatDateStr('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Return Time" with="300" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <i v-if="scope.row.returnTime" class="el-icon-time"></i>
                        <span> {{ scope.row.returnTime | formatDateStr('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>

        <el-pagination
            :page-size="query.limit"
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :total="total">
        </el-pagination>

    </div>

</template>

<script>
import {
    epcQuery,
    epcExport
} from "../../api/epc/epc";
import {
    brandList,
} from "../../api/auth/brand";
export default {
    data() {
        return {
            roles: [],
            eacList: [],
            deviceList: [],
            sellTime: [],
            query: {
                epcCode: "",
                page: 1,
                limit: 20,
                brandId: this.$store.state.admin.brandId,
                storeCode: "",
                sellTimeStart: "",
                sellTimeEnd: ""
            },
            brandList: [],
            list: [],
            total: 0,
            loading: true,
            deleteLoading: false
        };
    },
    methods: {
        onReset() {
            this.sellTime = [];
            this.query = {
                epcCode: "",
                page: 1,
                limit: 20,
                brandId: this.$store.state.admin.brandId,
                storeCode: "",
                sellTimeStart: "",
                sellTimeEnd: ""
            };
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        getList() {
            this.loading = true;
            if (this.sellTime && this.sellTime.length > 0) {
                this.query.sellTimeStart = this.sellTime[0];
                this.query.sellTimeEnd = this.sellTime[1];
            } else {
                this.query.sellTimeStart = "";
                this.query.sellTimeEnd = "";
            }
            epcQuery(this.query)
                .then(response => {
                    this.loading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.list = response.data.list || [];
                    this.total = response.data.total || 0;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                    this.roles = [];
                });
        },
        brandListFun(id){
            var label;
            this.brandList.map(function(item) {
                if (item.id == id) {
                    label = item.businessCode;
                }
            })
            return label;
        },
        eacListFun(id){
            var label
            this.eacList.map(function(item) {
                if (item.id == id) {
                    label = item.storeName;
                }
            })
            return label;
        },
        queryBrandList() {
            brandList({
                page: 1,
                limit: 50
            })
                .then(response => {
                    this.brandList = response.data.list;
                })
                .catch(() =>{

                });
        },
        exportCsv() {
            var data = {
                epcCode: this.query.epcCode,
                brandId: this.query.brandId,
                storeCode: this.query.storeCode,
                sellTimeStart: this.query.sellTimeStart,
                sellTimeEnd: this.query.sellTimeEnd,
                status: this.query.status
            };
            epcExport(data)
            .then(response => {
                if (response.code) {
                    this.$message.error(response.message);
                    return;
                }
                var time = new Date();
                var y = time.getFullYear();
                var m = (time.getMonth()+1)<10?"0"+(time.getMonth()+1):(time.getMonth()+1);
                var d = time.getDate()<10?'0'+time.getDate():time.getDate();
                var h = time.getHours();
                var mm = time.getMinutes();
                var s = time.getSeconds();
                const blob = new Blob([response]);
                const fileName = y+''+m+''+d+''+h+''+mm+''+s+' EPC Data.csv';
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href);
                document.body.removeChild(elink);
            })
            .catch(() => {

            });
        }
    },
    mounted() {},
    created() {
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.limit = parseInt(this.query.limit);
        this.onReset();
        this.queryBrandList()
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
